import configExample from "./config.example.json";

const configIsAppConfig = (config, missingKeys) => {
  return missingKeys.length === 0;
};

class AppConfig {
  _appConfigStore;

  set config(config) {
    const example = configExample;
    const filterUseKeys = Object.keys(example).filter(
      (key) => key.charAt(0) !== "_"
    );
    const missingKeys = [];
    for (const key of filterUseKeys) {
      if (typeof example[key] === typeof config[key]) {
        continue;
      }
      missingKeys.push(key);
    }
    if (configIsAppConfig(config, missingKeys)) {
      this._appConfigStore = config;
      return;
    }
    throw new Error(
      `Bad application configuration! Not set variables: ${missingKeys.join(
        ", "
      )}`
    );
  }

  get config() {
    if (!this._appConfigStore)
      throw new Error("Application configuration not exists");
    return this._appConfigStore;
  }
}

const appConfigStore = new AppConfig();

export default appConfigStore;
